export const OTHER_FEES_TYPE = {
  ADMIN_FEE_IN_ADVANCE: 'admin-fee-in-advance',
  BED_LINEN_AND_TOWELS: 'bed-linen-and-towels-fee',
  CHECK_IN_AND_CHECK_OUT_ON_WEEKENDS: 'check-in-and-or-check-out-on-weekends',
  CITY_REGISTRATION: 'city-registration',
  CITY_TAXES: 'city-taxes',
  CLEANING_FEE: 'cleaning-fee',
  CONDOMINIUM_FEE: 'condominium-fees',
  DEPOSIT_LAST_MONTH: 'deposit-last-month',
  EARLY_OR_LATE_HOURS_FOR_CHECK_IN_AND_CHECK_OUT: 'early-or-late-hours-for-check-in-and-check-out',
  FIXED_BILLS_FEE: 'fixed-bills-fee',
  LAST_MONTH_RENT_IN_ADVANCE: 'last-month-rent-in-advance',
  LAUNDRY_FEE: 'laundry-fee',
  OVERNIGHT_GUESTS: 'overnight-guests',
  PARKING_FEE: 'parking-fee',
  SECURITY_DEPOSIT_IN_ADVANCE: 'security-deposit-in-advance',
  SIGNATURE_AND_REGISTRATION_OF_THE_TENANCY_AGREEMENT: 'signature-and-registration-of-the-tenancy-agreement',
  VARIABLE_SECURITY_DEPOSIT: 'variable-security-deposit'
};

export const OTHER_FEES_TRANSLATION_KEYS = {
  [OTHER_FEES_TYPE.CHECK_IN_AND_CHECK_OUT_ON_WEEKENDS]: 'Check-in/Check-out in weekends',
  [OTHER_FEES_TYPE.CONDOMINIUM_FEE]: 'Condominium fees',
  [OTHER_FEES_TYPE.EARLY_OR_LATE_HOURS_FOR_CHECK_IN_AND_CHECK_OUT]: 'Early or late hours for check-in and check-out'
};

export const getOtherFeeTranslationKey = feeType => OTHER_FEES_TRANSLATION_KEYS[feeType];
